import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const CardVisaIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 40 29.9"
        xmlSpace="preserve"
        preserveAspectRatio="none"
        {...props}
      >
        <path
          d="M37.5 25.3H3.3c-1.4 0-2.5-1.1-2.5-2.5V3.1C.8 1.7 1.9.6 3.3.6h34.2C38.9.6 40 1.7 40 3.1v19.6c.1 1.5-1.1 2.6-2.5 2.6zM3.3 1.4c-.9 0-1.7.8-1.7 1.7v19.6c0 .9.8 1.7 1.7 1.7h34.2c.9 0 1.7-.8 1.7-1.7V3.1c0-.9-.8-1.7-1.7-1.7H3.3z"
          style={{ fill: '#dedede' }}
        />
        <path
          d="M24.8 8.4c-2.3 0-3.8 1.2-3.9 2.9 0 1.3 1.1 2 2 2.4.9.4 1.2.7 1.2 1.1 0 .6-.7.9-1.4.9-.9 0-1.4-.1-2.1-.5l-.3-.1L20 17c.5.2 1.5.5 2.5.5 2.4 0 4-1.2 4-3 0-1-.6-1.8-1.9-2.4-.8-.4-1.3-.7-1.3-1.1 0-.4.4-.8 1.3-.8.7 0 1.3.2 1.7.3l.2.1.3-1.9c-.4-.1-1.1-.3-2-.3zm-7.1.1-1.4 8.9h2.3L20 8.5h-2.3zm-3.4 0-2.2 6-.2-1.2c-.6-1.5-1.8-3.1-3.2-3.7l2 7.7h2.4l3.6-8.8h-2.4zm16.6 0c-.5 0-1 .2-1.2.7l-3.4 8.1h2.4s.4-1.1.5-1.3h2.9c.1.3.3 1.3.3 1.3h2.1l-1.9-8.8h-1.7zm.2 2.4.2.8s.4 2.1.5 2.6h-1.9c.2-.5.9-2.5.9-2.5s.2-.5.3-.9z"
          style={{ fill: '#0039af' }}
        />
        <path
          d="M10 8.5H6.3v.2c2.9.7 4.8 2.5 5.5 4.7L11 9.3c-.1-.6-.5-.7-1-.8"
          style={{ fill: '#ffb700' }}
        />
      </svg>
    );
  }
);
export default CardVisaIcon;
